module.exports = __webpack_public_path__ + "static/media/arrow2.13463c41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/arrow2.svg
// module id = 1886
// module chunks = 0